import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Check, Gift } from 'lucide-react';
export function ValueTableSection() {
  return <Section background="cream-dark" data-id="element-274">
      <div className="max-w-3xl mx-auto" data-id="element-275">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-xl overflow-hidden border border-brand-gold/20" data-id="element-276">
          <div className="bg-brand-charcoal-dark p-6 md:p-8 text-center" data-id="element-277">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-278">
              LO QUE OBTIENES HOY
            </h2>
          </div>

          <div className="p-6 md:p-10" data-id="element-279">
            <div className="flex justify-between text-xs font-bold text-brand-charcoal/40 tracking-wider mb-4 pb-2 border-b border-brand-gold/10" data-id="element-280">
              <span data-id="element-281">PRODUCTO / BONO</span>
              <span data-id="element-282">VALOR</span>
            </div>

            <div className="space-y-4 mb-8" data-id="element-283">
              <div className="flex justify-between items-center py-2" data-id="element-284">
                <div className="flex items-center gap-3" data-id="element-285">
                  <div className="bg-brand-sage/20 p-1.5 rounded-full" data-id="element-286">
                    <Check className="h-4 w-4 text-brand-sage" data-id="element-287" />
                  </div>
                  <span className="font-medium text-brand-charcoal-dark" data-id="element-288">
                    Cortisol Off — Manual Operativo
                  </span>
                </div>
                <span className="text-brand-charcoal/60" data-id="element-289">$29.99</span>
              </div>

              <div className="flex justify-between items-center py-2" data-id="element-290">
                <div className="flex items-center gap-3" data-id="element-291">
                  <div className="bg-brand-gold/20 p-1.5 rounded-full" data-id="element-292">
                    <Gift className="h-4 w-4 text-brand-gold-dark" data-id="element-293" />
                  </div>
                  <span className="font-medium text-brand-charcoal-dark" data-id="element-294">
                    Bono #1: The 3PM Reset Checklist
                  </span>
                </div>
                <span className="text-brand-charcoal/60" data-id="element-295">$47.00</span>
              </div>

              <div className="flex justify-between items-center py-2" data-id="element-296">
                <div className="flex items-center gap-3" data-id="element-297">
                  <div className="bg-brand-gold/20 p-1.5 rounded-full" data-id="element-298">
                    <Gift className="h-4 w-4 text-brand-gold-dark" data-id="element-299" />
                  </div>
                  <span className="font-medium text-brand-charcoal-dark" data-id="element-300">
                    Bono #2: CEO Sleep Protocol
                  </span>
                </div>
                <span className="text-brand-charcoal/60" data-id="element-301">$47.00</span>
              </div>

              <div className="flex justify-between items-center py-2" data-id="element-302">
                <div className="flex items-center gap-3" data-id="element-303">
                  <div className="bg-brand-gold/20 p-1.5 rounded-full" data-id="element-304">
                    <Gift className="h-4 w-4 text-brand-gold-dark" data-id="element-305" />
                  </div>
                  <span className="font-medium text-brand-charcoal-dark" data-id="element-306">
                    Bono #3: High-Performance Morning Checklist
                  </span>
                </div>
                <span className="text-brand-charcoal/60" data-id="element-307">$47.00</span>
              </div>
            </div>

            <div className="border-t border-brand-gold/20 pt-6 space-y-4" data-id="element-308">
              <div className="flex justify-between items-center" data-id="element-309">
                <span className="font-bold text-brand-charcoal/60" data-id="element-310">
                  VALOR TOTAL
                </span>
                <span className="font-bold text-brand-charcoal/60 line-through" data-id="element-311">
                  $170.99
                </span>
              </div>

              <div className="flex justify-between items-center bg-brand-cream p-4 rounded-lg border border-brand-gold/30" data-id="element-312">
                <span className="text-xl font-bold text-brand-charcoal-dark" data-id="element-313">
                  TÚ PAGAS HOY
                </span>
                <span className="text-3xl font-bold text-brand-gold-dark" data-id="element-314">
                  $6.36
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-10 text-center max-w-2xl mx-auto" data-id="element-315">
          <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-316">
            <span className="font-bold text-brand-charcoal-dark" data-id="element-317">
              No estás comprando un PDF.
            </span>{' '}
            Estás obteniendo un sistema completo de regulación del rendimiento
            mental: para el colapso de media tarde, para el final del día y para
            arrancar mañana como el CEO que ya eres.
          </p>
          <p className="mt-4 font-serif italic text-brand-gold-dark text-xl" data-id="element-318">
            Todo por menos de lo que cuesta un café con leche.
          </p>
        </motion.div>
      </div>
    </Section>;
}